import { render, staticRenderFns } from "./FeedingRecordDetail.vue?vue&type=template&id=5c1d22df&scoped=true"
import script from "./FeedingRecordDetail.vue?vue&type=script&lang=js"
export * from "./FeedingRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./FeedingRecordDetail.vue?vue&type=style&index=0&id=5c1d22df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d22df",
  null
  
)

export default component.exports